export const SUPER_PERMISSION = '*';

export const normalizePermissions = (permissions) => {
    if (!Array.isArray(permissions)) return [];

    return permissions.filter((permission) => typeof permission === 'string' && permission.trim() !== '');
};

export const hasPermission = (permissions, requiredPermission) => {
    const normalizedPermissions = normalizePermissions(permissions);

    if (!requiredPermission || typeof requiredPermission !== 'string') return false;
    if (normalizedPermissions.length === 0) return false;
    if (normalizedPermissions.includes(SUPER_PERMISSION)) return true;

    return normalizedPermissions.includes(requiredPermission);
};

export const hasAnyPermission = (permissions, requiredPermissions = []) => {
    const normalizedRequiredPermissions = normalizePermissions(requiredPermissions);

    if (normalizedRequiredPermissions.length === 0) return false;

    return normalizedRequiredPermissions.some((permission) => hasPermission(permissions, permission));
};

export const hasAllPermissions = (permissions, requiredPermissions = []) => {
    const normalizedRequiredPermissions = normalizePermissions(requiredPermissions);

    if (normalizedRequiredPermissions.length === 0) return false;

    return normalizedRequiredPermissions.every((permission) => hasPermission(permissions, permission));
};
